import { CountList } from "pages/Inventori/Register/ItemCount/type"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"


type FilterState = {
    start_date?: string
    end_date?: string
    product_id?: number
}

export function useList({ start_date, end_date, product_id}: FilterState) {

    const api = useApi();
    const [data, setData] = useState<CountList[]>([]);
    const [isLoading, setLoading] = useState(true)

    const params: { [key: string]: number | string | undefined } = {}
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    if (product_id) params.product_id = product_id

    const fetchUrl = () => {
        return api.get("/invcount/register_count_by_id?",{params})
    }

    const fetchData = () => {
        setLoading(true);

        fetchUrl().then((res: SuccessFetch<{payload: CountList[]}>) => {
            setData(res.data.payload);
        }).catch(() => {
            setData([]);
        }).finally(() => {
            setLoading(false);
        });
    }

    const refetch = () => fetchData();

    useEffect(() => {
        fetchData();

        return () => {
            setData([]);
            setLoading(true);
        }
        // eslint-disable-next-line
    }, [start_date, end_date, product_id]);

    return { data, isLoading, refetch }
}